import React, { useState, useCallback } from 'react';
import { Select } from '@input';
import ProductTypes from '@components/Content/ProductTypes';
import useMatchMedia from '@hooks/useMatchMedia';
import useHasRendered from '@hooks/useHasRendered';
import * as styles from './ToolbarContent.module.scss';
import classNames from 'classnames';
import { sortStates } from '@enums';

const options = Object.values(sortStates);

export default React.memo(function ToolbarContent({
  isSticky,
  canShowContent,
  sort,
  setSort,
  productTypes,
  isLoading,
  isLoadingCategory,
  isDisabled,
  toggleProductCategory,
  toggleProductType
}) {
  const sortText = useMatchMedia(970, 'Sort:', 'Sort by:');
  const isModalProductTypes = useMatchMedia(1080);
  const hasRendered = useHasRendered();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(() => setModalIsOpen(true), []);
  const closeModal = useCallback(() => setModalIsOpen(false), []);

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.showContent]: canShowContent
      })}
    >
      <div className={styles.productTypes}>
        {hasRendered && (
          <ProductTypes
            forceDropdown
            productTypes={productTypes}
            className="toolbar-products"
            aria-hidden={!isSticky}
            isModal={isModalProductTypes}
            modalIsOpen={modalIsOpen}
            openModal={openModal}
            closeModal={closeModal}
            categoryButtonClassName={styles.productCategory}
            categoryTabIndex={!canShowContent ? -1 : null}
            direction="horizontal"
            dropdownTextBreakpoint={1065}
            spinnerSize={15}
            isLoading={isLoading}
            isLoadingCategory={isLoadingCategory}
            toggleProductCategory={toggleProductCategory}
            toggleProductType={toggleProductType}
          />
        )}
      </div>
      <Select
        fieldClassName={styles.sort}
        options={options}
        value={sort}
        theme="minimal"
        inlineLabel={sortText}
        isDisabled={isDisabled}
        aria-controls="calculator-rate-table"
        usePortal={!isSticky}
        offsetEmptyRight={true}
        onChange={setSort}
      />
    </div>
  );
});
